// third-party
import { FormattedMessage } from "react-intl";
import {
  LocusAnalyticsDashboardsIcon,
  LocusReportsIcon,
} from "../assets/icons/LocusIcons.js";
import {
  CROSS_SITE_VIEWER,
  LOCUS_ASSET_MANAGER,
  LOCUS_TENANT,
  VIEWER,
  SUPER_ADMIN,
} from "../utils/constants/user";
import * as React from "react";

// ==============================|| APPLICATION MENU ITEMS ||============================== //
/** @type {LocusMenuGroup} */
const analytics = {
  id: "analytics",
  title: <FormattedMessage id="analytics" />,
  type: "group",
  view: ["locus", "site"],
  children: [
    {
      id: "dashboards",
      title: <FormattedMessage id="dashboards" />,
      type: "item",
      icon: LocusAnalyticsDashboardsIcon,
      url: "dashboards?site=:siteId",
      allowedGroups: [LOCUS_TENANT, CROSS_SITE_VIEWER, VIEWER],
      view: ["site"],
    },
    {
      id: "reports",
      title: <FormattedMessage id="reports" />,
      type: "item",
      icon: LocusReportsIcon,
      url: "reports?site=:siteId",
      allowedGroups: [LOCUS_TENANT, CROSS_SITE_VIEWER, VIEWER],
      view: ["site"],
    },
    {
      id: "reports-tools",
      title: <FormattedMessage id="reports" />,
      type: "collapse",
      icon: LocusReportsIcon,
      view: ["locus"],
      children: [
        {
          id: "robot-assets",
          title: <FormattedMessage id="bot-assets" />,
          type: "item",
          url: "reports/robot-assets",
          breadcrumbs: true,
          view: ["locus"],
          allowedGroups: [LOCUS_ASSET_MANAGER],
        },
        {
          id: "global-site-health",
          title: <FormattedMessage id="global-site-health" />,
          type: "item",
          url: "reports/global-site-health",
          breadcrumbs: true,
          view: ["locus"],
          allowedGroups: [LOCUS_TENANT],
        },
      ],
    },
    {
      id: "custom-dashboards",
      title: <FormattedMessage id="custom-dashboards" />,
      type: "collapse",
      icon: LocusAnalyticsDashboardsIcon,
      view: ["site"],
      children: [
        {
          id: "taskmap",
          title: <FormattedMessage id="taskmap" />,
          type: "item",
          url: "custom-dashboards?site=:siteId&dashboard=65294cf5451d635db639a9ef",
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
        // {
        //   id: "associateperformance",
        //   title: <FormattedMessage id="associateperformance" />,
        //   type: "item",
        //   url: "custom-dashboards?site=:siteId&dashboard=65294d27451d635db639a9f0",
        //   breadcrumbs: true,
        //   view: ["site"],
        //   allowedGroups: [SUPER_ADMIN],
        // },
        // {
        //   id: "directedassociateperformance",
        //   title: <FormattedMessage id="directedassociateperformance" />,
        //   type: "item",
        //   url: "custom-dashboards?site=:siteId&dashboard=66e1b6b5db02a27df55c538e",
        //   breadcrumbs: true,
        //   view: ["site"],
        //   allowedGroups: [SUPER_ADMIN],
        // },
        // {
        //   id: "induction",
        //   title: <FormattedMessage id="induction" />,
        //   type: "item",
        //   url: "custom-dashboards?site=:siteId&dashboard=65294e94451d635db639a9f3",
        //   breadcrumbs: true,
        //   view: ["site"],
        //   allowedGroups: [SUPER_ADMIN],
        // },
        // {
        //   id: "openwork",
        //   title: <FormattedMessage id="openwork" />,
        //   type: "item",
        //   url: "custom-dashboards?site=:siteId&dashboard=65294dc5451d635db639a9f1",
        //   breadcrumbs: true,
        //   view: ["site"],
        //   allowedGroups: [SUPER_ADMIN],
        // },
        {
          id: "overview",
          title: <FormattedMessage id="overview" />,
          type: "item",
          url: "custom-dashboards?site=:siteId&dashboard=657b163cbf24104fab0f6769",
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
        // {
        //   id: "workassignment",
        //   title: <FormattedMessage id="workassignment" />,
        //   type: "item",
        //   url: "custom-dashboards?site=:siteId&dashboard=65294ef1451d635db639a9f4",
        //   breadcrumbs: true,
        //   view: ["site"],
        //   allowedGroups: [SUPER_ADMIN],
        // },
      ],
    },
  ],
};

export default analytics;
